import React, { useContext, useEffect, useState } from 'react'

import { Row, Col } from 'react-bootstrap'
import ChartContent from '../../components/Chart/ChartContent'
import { STable, SDashboard } from '../sharedSectionStyles'
import { getBackendData } from '../../api/api'
import { IAssetPrice, ITokenHolder } from '../../api/interfaces'
import { dateFormatter, nFormatter } from '../../utils/numbers'
import { minimizeAddress, getEtherscanAddressLink } from '../../utils/address'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import WideCard from '../../components/WideCard.tsx/WideCard'
import { getTSThorStakingConfig } from './TSThorStaking'
import { getTSStakingAPRConfig } from './TSStakingAPR'
import { getTSStakingYieldConfig } from './TSStakingYield'
import { getTSThorPriceConfig } from './TSThorPrice'
import { ThemeContext } from '../../App'

// async function getThorPriceConfig() {
// 	const chartData = (await getBackendData('thorswap', 'thor_price', '1d')) as IAssetPrice[]
// 	const series1 = chartData.map((element: IAssetPrice) => {
// 		return { x: new Date(element.DAY.replace(' ', 'T') + 'Z').getTime() / 1000, y: element.ASSET_PRICE_USD }
// 	})
// 	const config: IChart[] = [
// 		{
// 			data: series1,
// 			strokeWidth: 2,
// 			name: 'thor price',
// 			type: 'line' as 'line' | 'bars',
// 			seriesGroup: '[usd]',
// 			color: 'orange',
// 			unitSymbol: '$'
// 		}
// 	]
// 	return { config: config, latestValue: series1[series1.length - 1].y, latestValueDate: series1[series1.length - 1].x }
// }

const ThorswapFeaturedDashboard = () => {
	const { setTheme, theme } = useContext(ThemeContext)

	const [thorHoldersData, setThorHoldersData] = useState<ITokenHolder[]>()

	const [dataSeries2, setDataSeries2] = useState<IChartConfig | undefined>(undefined)
	const [dataSeries4, setDataSeries4] = useState<IChartConfig | undefined>(undefined)
	const [dataSeries5, setDataSeries5] = useState<IChartConfig | undefined>(undefined)
	const [dataSeries6, setDataSeries6] = useState<IChartConfig | undefined>(undefined)

	const InitializeData = async (color: string, inverseColor: string) => {
		try {
			setThorHoldersData(await getBackendData('thorswap', 'thor_holders'))
			setDataSeries2(await getTSThorPriceConfig(color, inverseColor, '1d'))
			setDataSeries4(await getTSThorStakingConfig(color, inverseColor, '1m'))
			setDataSeries5(await getTSStakingAPRConfig(color, inverseColor, '1d'))
			setDataSeries6(await getTSStakingYieldConfig(color, inverseColor, '1w'))
		} catch (error) {
			console.log(error)
		}
	}
	useEffect(() => {
		let mainColor = theme === 'dark' ? 'white' : 'black'
		let inverseMainColor = theme === 'dark' ? 'black' : 'white'
		InitializeData(mainColor, inverseMainColor)
	}, [theme])
	if (thorHoldersData !== undefined && dataSeries2 !== undefined && dataSeries4 !== undefined && dataSeries5 !== undefined && dataSeries6 !== undefined) {
		return (
			<SDashboard>
				<Row>
					<Col>
						<ChartContent
							dataSeries={dataSeries2.config}
							chartHeight="35vh"
							chartWidth="100%"
							chartTitle="THOR/RUNE"
							isMinimalChart={true}
							hasLogScale={false}
							startZoom={Date.now() / 1000 - 3600 * 24 * 30 * 12}
						/>
					</Col>
					<STable className="table">
						<caption>Top 10 holders of THOR</caption>
						<thead>
							<tr>
								<th>#</th>
								<th>Address</th>
								<th>THOR Holdings</th>
							</tr>
						</thead>
						<tbody>
							{thorHoldersData.slice(0, 10).map((holder: ITokenHolder) => (
								<tr key={holder.USER_ADDRESS}>
									<th>{thorHoldersData.slice(0, 10).findIndex((item) => item.USER_ADDRESS === holder.USER_ADDRESS) + 1}</th>
									<td>
										<a href={getEtherscanAddressLink(holder.USER_ADDRESS)} target="_blank" rel="noreferrer">
											{minimizeAddress(holder.USER_ADDRESS)}
										</a>
									</td>
									<td>{nFormatter(holder.BALANCE)}</td>
								</tr>
							))}
						</tbody>
					</STable>
				</Row>

				<Row>
					<Col>
						<ChartContent
							dataSeries={dataSeries5.config}
							chartHeight="35vh"
							chartWidth="100%"
							chartTitle="THOR Staking APR"
							isMinimalChart={true}
							hasLogScale={false}
							startZoom={Date.now() / 1000 - 3600 * 24 * 30 * 4}
						/>
					</Col>
				</Row>
				<br />

				<Row>
					<Col>
						<WideCard cardTitle="THOR TVL" cardValue={`${nFormatter(dataSeries4.latestValue)} THOR`} cardValueDate={`${dateFormatter(dataSeries4.latestValueDate)}`} link="/thorswap_staking" />
						<ChartContent dataSeries={dataSeries4.config} chartHeight="35vh" chartWidth="100%" chartTitle="" isMinimalChart={true} hasLogScale={false} />
					</Col>
					<Col>
						<WideCard
							cardTitle="THOR Staking Yield"
							cardValue={`$${nFormatter(dataSeries6.latestValue)}`}
							cardValueDate={`${dateFormatter(dataSeries6.latestValueDate)}`}
							link="/thorswap_staking_yield"
						/>
						<ChartContent
							dataSeries={dataSeries6.config}
							chartHeight="35vh"
							chartWidth="50%"
							chartTitle=""
							isMinimalChart={true}
							hasLogScale={false}
							startZoom={Date.now() / 1000 - 3600 * 24 * 30 * 6}
						/>
					</Col>
				</Row>
			</SDashboard>
		)
	} else {
		return <LoadingChart />
	}
}

export default ThorswapFeaturedDashboard
